import { render, staticRenderFns } from "./SendRmaToSpedimexModal.vue?vue&type=template&id=0befe17f&scoped=true&"
import script from "./SendRmaToSpedimexModal.vue?vue&type=script&lang=js&"
export * from "./SendRmaToSpedimexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0befe17f",
  null
  
)

export default component.exports